export default {
  // API: "http://127.0.0.1:8100",
  API: "https://csapi.nghienorder.vn",
  CLSAPI: "https://clapi.nghienorder.vn",
  DOMAIN: "https://nghienorder.vn",
  MEDIADOMAIN: 'https://media.nghienorder.vn',
  SHORT_DATE_FORMAT: "DD-MM-YYYY",
  DATE_FORMAT: "DD/MM/YYYY HH:mm:ss",
  SQL_DATE_FORMAT: "YYYY-MM-DD HH:mm:ss",
  PAGINATION: {
    page: 1,
    itemsPerPage: 20,
    mustSort: true,
    sortDesc: [1],
    sortBy: ["ID"]
  },
  ITEMS_PER_PAGE:{
    'items-per-page-options': [20, 30, 40, 50]
  },
  COLOR_CHART: {
    blue: '#4C84FF',
    blue_light: '#A9C4FF',
    red: '#dc3545',
    red_light: '#FE9FA5'
  },
  COMPARE_PERIOD: [
    'Previous period',
    'Previous month',
    'Previous year'
  ],
  ORDER_STATUS_ENUM: {
    cho_dat_coc: 0,
    huy: 1,
    da_dat_coc: 2,
    da_mua_hang: 5,
    dang_van_chuyen: 16,
    da_nhap_kho_tq: 11,
    dang_chuyen_ve_vn: 12,
    da_nhap_kho: 7,
    cho_thanh_toan: 8,
    da_thanh_toan: 9,
    khieu_nai: 13,
    hoan_thanh:10
  },
  ORDER_STATUS: [
    { value: 1, name: 'Hủy đơn hàng', disabled: true, color: '#000000', textColor: '#ffffff' },
    { value: 5, name: 'Đã mua hàng', disabled: true, color: '#0489B1', textColor: '#ffffff' },
    // { value: 12, name: 'Vận chuyển về VN', disabled: false, color: '#2d8659', textColor: '#ffffff' },
    { value: 7, name: 'Đã nhập kho VN', disabled: true, color: 'green', textColor: '#ffffff' },
    { value: 0, name: 'Chờ đặt cọc', disabled: true, color: '#DF0101', textColor: '#ffffff' },
    { value: 16, name: 'Shop phát hàng', disabled: false, color: '#F7819F', textColor: '#ffffff' },
    // { value: 8, name: 'Chờ thanh toán', color: '#FACC2E', textColor: '#ffffff' },
    { value: 9, name: 'Đã thanh toán', disabled: true, color: '#0000FF', textColor: '#ffffff' },
    { value: 2, name: 'Đã đặt cọc', disabled: true, color: '#0B610B', textColor: '#ffffff' },
    { value: 11, name: 'Vận chuyển về VN', disabled: false, color: '#FE9A2E', textColor: '#ffffff' },
    { value: 13, name: 'Khiếu nại', disabled: true, color: '#D358F7', textColor: '#ffffff' },
    { value: 10, name: 'Hoàn thành', disabled: true, color: '#A4A4A4', textColor: '#ffffff' },
  ],
  ORDER_DEPOSIT_STATUS_ENUM: {
    dang_van_chuyen: 16,
    da_nhap_kho_vn: 11,
    dang_chuyen_ve_vn: 12,
    da_nhap_kho: 7,
    cho_thanh_toan: 8,
    da_thanh_toan: 9,
    hoan_thanh: 10,
    huy_don_hang: 1
  },
  ORDER_DEPOSIT_STATUS: [
    { value: 1, name: 'Hủy đơn hàng', color: '#000000', textColor: '#ffffff' },
    { value: 16, name: 'Shop phát hàng', color: '#F7819F', textColor: '#ffffff' },
    { value: 11, name: 'Vận chuyển về VN', color: '#FE9A2E', textColor: '#ffffff' },
    // { value: 12, name: 'Vận chuyển về VN', color: '#2d8659', textColor: '#ffffff' },
    { value: 7, name: 'Đã nhập kho VN', color: 'green', textColor: '#ffffff' },
    // { value: 8, name: 'Chờ thanh toán', color: '#FACC2E', textColor: '#ffffff' },
    { value: 9, name: 'Đã thanh toán', color: '#0000FF', textColor: '#ffffff' },
    { value: 10, name: 'Hoàn thành', color: '#A4A4A4', textColor: '#ffffff' },
  ],
  VIP_LEVEL: [
    { value: 1, name: '', color: '' },
    { value: 2, name: 'v1', color: '#FFCC80' },
    { value: 3, name: 'v2', color: '#FFB74D' },
    { value: 4, name: 'v3', color: '#FFA726' },
    { value: 5, name: 'v4', color: '#FB8C00' },
    { value: 6, name: 'v5', color: '#F57C00' },
    { value: 7, name: 'v6', color: '#EF6C00' },
  ],
  ORDER_MENU: [
    { id: 0, name: 'Tất cả', status: [] },
    { id: 1, name: 'Chờ đặt cọc', status: [0] },
    { id: 2, name: 'Hủy đơn hàng', status: [1] },
    { id: 3, name: 'Khách đã đặt cọc', status: [2] },
    { id: 4, name: 'Đã mua hàng', status: [5] },
    { id: 5, name: 'Shop đã phát hàng', status: [6] },
    { id: 6, name: 'Đã nhận hàng tại VN', status: [7] },
    { id: 7, name: 'Chờ thanh toán', status: [8] },
    { id: 8, name: 'Khách đã thanh toán', status: [9] },
    { id: 9, name: 'Khiếu nại', status: [12, 13, 14] },
  ],
  PACKAGE_STATUS_ENUM: {
    CHUA_PHAT_HANG: 0,
    DANG_DI_CHUYEN: 1,
    DA_VE_TQ: 2,
    DANG_VE_TQ: 3,
    DA_VE_VN: 4,
    KH_DA_NHAN: 5
  },
  PACKAGE_STATUS: [
    { value: 0, name: 'Chưa phát hàng', disabled: true, color: 'red', textColor: '#000' },
    { value: 1, name: 'Shop phát hàng', disabled: false, color: 'black', textColor: '#FFF' },
    { value: 2, name: 'Đang về VN', disabled: false, color: '#FFB74D', textColor: '#FFF' },
    { value: 3, name: 'Đang về VN', disabled: false, color: '#2d8659', textColor: '#FFF' },
    { value: 4, name: 'Đã về kho VN', disabled: false, color: 'green', textColor: '#FFF' },
    { value: 5, name: 'Đã giao hàng', disabled: false, color: 'blue', textColor: '#FFF' },
  ],
  COMMENT_TYPE: [
    { value: 1, name: 'Công khai', color: '#2EBB32' },
    { value: 2, name: 'Nội bộ', color: '#dc3545' }
  ],
  CUSTOMER_STATUS: {
    InActive: 1,
    Actived: 2,
    Blocked: 3
  },
  CUSTOMER_STATUS_LIST: [
    { value: 1, name: 'Chưa kích hoạt', color: '#808080' },
    { value: 2, name: 'Đã kích hoạt', color: '#0059b3' },
    { value: 3, name: 'Đang bị khóa', color: '#e63900' },
  ],
  RECHARGE_STATUS: {
    Pending: 1,
    Approved: 2,
    Cancel: 3,
    Transferred: 4,
    Cash: 5,
  },
  RECHARGE_STATUS_LIST: [
    // { value: 1, name: 'Chờ duyệt', color: '#808080', textColor: '#000' },
    { value: 2, name: 'Thành công', color: '#0059b3', textColor: '#FFF' },
    { value: 3, name: 'Hủy', color: '#e63900', textColor: '#000' },
    // { value: 4, name: 'Chuyển khoản', color: '#00b300', textColor: '#FFF' },
    // { value: 5, name: 'Tiền mặt', color: '#2d8659', textColor: '#FFF' },
  ],
  WITHDRAW_STATUS: {
    Pending: 1,
    Approved: 2,
    Cancel: 3,
  },
  WITHDRAW_STATUS_LIST: [
    { value: 1, name: 'Chờ duyệt', color: '#dc3545', textColor: '#000' },
    { value: 2, name: 'Đã duyệt', color: '#0059b3', textColor: '#FFF' },
    { value: 3, name: 'Hủy lệnh', color: '#e63900', textColor: '#000' }
  ],
  PAYMENT_TYPE: {
    Deposit: 1,
    Complete: 2,
  },
  PAYMENT_TYPE_LIST: [
    { value: 1, name: 'Đặt cọc', color: '#2d8659', textColor: '#FFF' },
    { value: 2, name: 'Thanh toán', color: '#0059b3', textColor: '#FFF' },
  ],
  PAYMENT_STATUS_LIST: [
    { value: 2, name: 'Đặt cọc', color: '#2d8659', textColor: '#FFF' },
    { value: 9, name: 'Thanh toán', color: '#0059b3', textColor: '#FFF' },
    { value: 10, name: 'Phí ship', color: '#808080', textColor: '#FFF' },
    { value: 12, name: 'Nhận lại cọc', color: '#FFB74D', textColor: '#000' },
  ],
  COMPLAIN_STATUS: {
    Cancel: 0,
    Processing: 2,
    Pending: 1,    
    Done: 3,
  },
  COMPLAIN_STATUS_LIST: [
    { value: 0, name: 'Hủy', color: 'orange' },
    { value: 2, name: 'Đang xử lý', color: 'green' },
    { value: 1, name: 'Chờ xử lý', color: 'red' },    
    { value: 3, name: 'Đã xử lý', color: 'blue' }
  ],
  RECHARGE_TYPE: {
    Techcombank: 1,
    Vietcombank: 2,
    BIDV: 3,
    Cash: 4,
    COD: 5,
    VPbank: 6,
  },
  RECHARGE_METHODS: [
    { value: 1, name: 'Techcombank'},
    { value: 2, name: 'Vietinbank'},
    { value: 3, name: 'Vietcombank'},
    { value: 6, name: 'VP Bank'},
    { value: 4, name: 'Cash'},
    { value: 5, name: 'COD'},
  ],
  DATA_TYPE: {
    String: 0,
    Number: 1,
    Enum: 2,
    Date: 3
  },
  LIST_COMPARISON: [
    { name: 'Có chứa', value: 'contain', display: '({0})', dataType: 0 },
    { name: 'Không chứa', value: 'does_not_contain', display: '-({0})', dataType: 0 },
    { name: 'Bằng', value: 's_equal', display: '= {0}', dataType: 0 },
    { name: 'Khác', value: 's_does_not_equal', display: '!= {0}', dataType: 0 },
    { name: 'Bằng', value: 'equal', display: '= {0}', dataType: 1 },
    { name: 'Khác', value: 'does_not_equal', display: '!= {0}', dataType: 1 },
    { name: 'Lớn hơn', value: 'greater_than', display: '> {0}', dataType: 1 },
    { name: 'Lớn hơn hoặc bằng', value: 'greater_than_or_equal', display: '>= {0}', dataType: 1 },
    { name: 'Nhỏ hơn', value: 'less_than', display: '< {0}', dataType: 1 },
    { name: 'Nhỏ hơn hoặc bằng', value: 'less_than_or_equal', display: '<= {0}', dataType: 1 },
    { name: 'Bằng', value: 'in', display: '= [{0}]', dataType: 2 },
    { name: 'Khác', value: 'not_in', display: '!= [{0}]', dataType: 2 },
    { name: 'Bằng', value: 'd_equal', display: '= {0}', dataType: 3 },
    { name: 'Khác', value: 'd_does_not_equal', display: '!= {0}', dataType: 3 },
    { name: 'Lớn hơn', value: 'd_greater_than', display: '> {0}', dataType: 3 },
    { name: 'Lớn hơn hoặc bằng', value: 'd_greater_than_or_equal', display: '>= {0}', dataType: 3 },
    { name: 'Nhỏ hơn', value: 'd_less_than', display: '< {0}', dataType: 3 },
    { name: 'Nhỏ hơn hoặc bằng', value: 'd_less_than_or_equal', display: '<= {0}', dataType: 3 },
  ],
  ROLE_TYPE: {
    Admin: 1,
    Manager: 2,
    Purchase: 4,
    CustomerService: 8,
    InteralControl: 16,
    StoreVN: 32,
    StoreTQ: 64,
    Payment: 128,
  },
  ROLES: [
    { value: 1, name: 'Admin'},
    // { value: 2, name: 'Quản lý'},
    { value: 4, name: 'Mua hàng'},
    { value: 8, name: 'Chăm sóc khách hàng'},
    // { value: 16, name: 'Interal Control'},
    { value: 32, name: 'Kho Việt Nam'},
    { value: 64, name: 'Kho Trung Quốc'},
    { value: 128, name: 'Thanh toán'},
  ],
  TRADE_TYPE: [
    { value: 1, name: 'Đặt cọc'},
    { value: 2, name: 'Nhận lại tiền đặt cọc' },
    { value: 3, name: 'Thanh toán hóa đơn' },
    { value: 4, name: 'Nạp tiền' },
    { value: 5, name: 'Rút tiền' },
    { value: 6, name: 'Hủy lệnh rút tiền' },
    { value: 7, name: 'Xử lý khiếu nại' },
    { value: 8, name: 'Hủy lệnh chuyển tiền' },
  ],
  SIGNAL_TYPE: [
    { value: 0, name: 'Chưa ký nhận'},
    { value: 1, name: 'Đã ký nhận' },
    { value: 2, name: 'Khác' }
  ],
  MONEY_SOURCES: [
    { value: 0, name: 'Guest'},
    { value: 1, name: 'Cash' },
    { value: 2, name: 'Vietcombank' },
    { value: 3, name: 'BIDV' },
    { value: 4, name: 'Techcombank' },
    { value: 5, name: 'Yuan' },
    { value: 6, name: 'System' }
  ],
  MONEY_COMMANDS: [
    { value: 0, name: 'Khách nạp ví', type: 0},
    { value: 1, name: 'Chuyển tiền nội bộ', type: 0 },
    { value: 2, name: 'Rút cổ tức', type: 1, pay: 1 },
    { value: 3, name: 'Mua tệ', type: 1, pay: 1 },
    { value: 4, name: 'Nạp tệ', type: 0, pay: 1 },
    { value: 5, name: 'Khách rút tiền', type: 1 },
    { value: 6, name: 'Thanh toán lương', type: 1, pay: 1 },
    { value: 7, name: 'Thanh toán tiền hàng', type: 1, pay: 1 },
    { value: 8, name: 'Khác', type: 1, pay: 1 },
  ]
};